document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('.megamenu-toggle');
    const closeButtons = document.querySelectorAll('.close-submenu');
    const html = document.documentElement; // Selecciona la etiqueta <html>

    function handleClick(e) {
        e.preventDefault();
        const submenu = this.nextElementSibling;
        const isOpen = this.classList.contains('open');

        // Cerrar otros submenús
        toggles.forEach(toggle => {
            toggle.classList.remove('open');
            toggle.nextElementSibling.classList.remove('open');
            html.classList.remove('is-megamenu');

        });

        // Abrir el submenú correspondiente
        if (!isOpen) {
            this.classList.add('open');
            submenu.classList.add('open');
        }

        html.classList.add('is-megamenu');
    }

    function handleCloseClick(e) {
        e.preventDefault();
        const submenu = this.closest('.megamenu__submenu');
        submenu.classList.remove('open');
        submenu.previousElementSibling.classList.remove('open');
        html.classList.remove('is-megamenu');

    }


    // Añadir eventos a los botones de toggle
    toggles.forEach(toggle => {
        toggle.addEventListener('click', handleClick);
    });

    // Añadir eventos a los botones de cerrar
    closeButtons.forEach(button => {
        button.addEventListener('click', handleCloseClick);
        html.classList.remove('is-megamenu');
    });

    // Asignar el evento de clic a cada opción del submenú
    document.querySelectorAll('.megamenu__submenu a').forEach(option => {
        option.addEventListener('click', handleOptionClick);
    });

    // Cerrar el submenú si se hace clic fuera del menú o submenú
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.megamenu-toggle') && !e.target.closest('.megamenu__submenu')) {
            toggles.forEach(toggle => {
                toggle.classList.remove('open');
                toggle.nextElementSibling.classList.remove('open');
                html.classList.remove('is-megamenu');

            });
        }
    });
});
